"use strict";

exports.__esModule = true;
exports.tripPlannerRoute = tripPlannerRoute;
exports.TripPlannerPath = exports.PlannerSegment = exports.TripPlannerTitle = void 0;

var _createRoute = require("../../../../../react-static/route/createRoute");

var _getPath = require("../../../../../react-static/route/getPath");

var _Trip = require("../Trip");

var TripPlannerTitle = "Trip Planner";
exports.TripPlannerTitle = TripPlannerTitle;
var PlannerSegment = "planner";
exports.PlannerSegment = PlannerSegment;
var TripPlannerPath = (0, _getPath.getPath)(PlannerSegment, _Trip.TripPath);
exports.TripPlannerPath = TripPlannerPath;

function tripPlannerRoute(rootPath) {
  var route = (0, _createRoute.createRoute)(rootPath, TripPlannerPath);

  route.getData = function () {
    return {
      path: TripPlannerPath
    };
  };

  return route;
}